import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { GIFTING_QUERY_PARAM } from 'Utils/Constants';
import { SmartLink } from 'Components/SmartLink';
import { isSignUpPage, isSignUpPlans } from 'Utils/PathVerification';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import './UserMenu.css';

const trackMenuEvent = (itemTitle) =>
  trackEvent(TRACKING_ENUMS.EVENT_GLOBAL_NAV_CLICK, {
    page_item_title: itemTitle,
  });

const UserMenuItem = (itemProps) => (
  <li className="userMenuPanelItem" role="menuitem">
    <SmartLink className="userListLink" onClick={() => trackMenuEvent(itemProps.text)} {...itemProps} />
  </li>
);

export class UserMenuComponent extends Component {
  state = {
    isOpen: false,
    isClickedToOpen: false,
  };

  clickToggle = () => {
    this.setState(({ isOpen, isClickedToOpen }) => ({
      isOpen: !isOpen,
      isClickedToOpen: !isClickedToOpen,
    }));
  };

  handleOnMouseEnter = () => {
    this.setState({ isOpen: true, isClickedToOpen: false });
  };

  closePanel = () => {
    this.setState({ isOpen: false, isClickedToOpen: false });
  };

  getSignInSearch = () => {
    const { isGifting, pathname, locationSearch } = this.props;
    let search = '';
    if (isGifting) {
      search = GIFTING_QUERY_PARAM;
    } else if (isSignUpPage(pathname)) {
      search = `return_to=${pathname}${locationSearch}`; //includes params
    }
    return search;
  };

  render() {
    const { user, routes, segmentProps, defaultConfig } = this.props;
    const { showSignInHeader, rootDomain, helpCenterPage } = defaultConfig;
    const { isOpen, isClickedToOpen } = this.state;
    const hoverState = isOpen && isClickedToOpen ? 'open' : isOpen ? '' : 'close';

    if (user.isAuthenticated || user.hasMvpd) {
      return (
        <div
          className="userMenu"
          onClick={this.clickToggle}
          onMouseEnter={this.handleOnMouseEnter}
          onMouseLeave={this.closePanel}
          role="menu"
        >
          <div className="userLabel" role="menuitem">
            <img className="profileIcon" src="/account/static/images/FN/profile-icon.svg" alt="My Account" />
            <img className="profileIconArrow" src="/account/static/images/FN/down-arrow.svg" alt="My Account" />
          </div>
          <div className={`hoverPanel ${hoverState}`}>
            <button id="containerBG" className="containerBG" type="button" onClick={this.closePanel} />
            <ul className="userMenuPanelList">
              <UserMenuItem text="Home" linkUrl={rootDomain} reload />
              <UserMenuItem text="My Account" linkUrl={routes.myAccount} />
              <UserMenuItem text="Help" linkUrl={helpCenterPage} reload />
              <UserMenuItem text="Sign Out" linkUrl={routes.signout} />
            </ul>
          </div>
        </div>
      );
    }

    if (showSignInHeader) {
      const { pathname } = this.props;
      const isSignUp = isSignUpPlans(pathname);
      return (
        <div className={`userMenu${isSignUp ? ' hasVariant' : ''}`}>
          <Link
            className="userLabel"
            role="menuitem"
            to={{
              pathname: routes.signin,
              search: this.getSignInSearch(),
              state: {
                page_source: (segmentProps && segmentProps.page_start_source) || 'general',
              },
            }}
            onClick={() => trackMenuEvent('Sign in')}
          >
            Sign in
          </Link>
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = ({ user, appConfig: { routes, defaultConfig }, purchaseMode: { isGifting = false } = {} }) => ({
  user,
  isGifting,
  defaultConfig,
  routes,
});

const ConnectedUserMenu = connect(mapStateToProps)(UserMenuComponent);
export default ConnectedUserMenu;
